var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import { Button } from '@pinwheel/origami';
import { useSelector } from 'react-redux';
import { DocumentUploadsType } from '../../types/document-uploads';
import DocumentUploadsFileInput from './DocumentUploadsFileInput';
import { uploadNewDocument } from '../../state/slices/slice-document-uploads';
import { useAppDispatch } from '../../state';
import { selectLinkToken, selectModalSessionId, selectUniqueUserId, } from '../../state/slices/slice-link-params';
import { EventAction } from '../../types/events';
import { useOpts } from '../../context';
// Wrapper around <Button> which opens up the Document Uploads file picker on
// click. This component kicks off the entire flow of uploading the file to S3
// and having the redux state update based on the responses.
var DocumentUploadsFileUploadButton = function (_a) {
    var onButtonClick = _a.onClick, onFilesAdded = _a.onFilesAdded, multiple = _a.multiple, customOrExistingDocumentId = _a.customOrExistingDocumentId, disabled = _a.disabled, restButtonProps = __rest(_a, ["onClick", "onFilesAdded", "multiple", "customOrExistingDocumentId", "disabled"]);
    var fileInputRef = useRef(null);
    var dispatch = useAppDispatch();
    var linkToken = useSelector(selectLinkToken);
    var modalSessionId = useSelector(selectModalSessionId);
    var uniqueUserId = useSelector(selectUniqueUserId);
    var opts = useOpts();
    var fireProperEventType = opts.fireProperEventType;
    return (React.createElement(React.Fragment, null,
        React.createElement(DocumentUploadsFileInput, { hidden: true, ref: fileInputRef, accept: "image/*,application/pdf", multiple: multiple, onFilesAdded: function (files) {
                files.forEach(function (file) {
                    fireProperEventType(EventAction.DOCUMENT_UPLOAD_FILE_SELECTED, opts, {
                        fileSize: file.size,
                        fileType: file.type,
                    });
                    // This check is needed because these fields are all nullable within
                    // the redux state, but in practice, will all be present.
                    if (linkToken && modalSessionId && uniqueUserId) {
                        void dispatch(uploadNewDocument({
                            linkToken: linkToken,
                            modalSessionId: modalSessionId,
                            uniqueUserId: uniqueUserId,
                            customOrExistingDocumentId: customOrExistingDocumentId,
                            documentType: DocumentUploadsType.PAYSTUB,
                            documentFile: file,
                        }));
                    }
                });
                onFilesAdded === null || onFilesAdded === void 0 ? void 0 : onFilesAdded(files);
            } }),
        React.createElement(Button, __assign({ disabled: disabled, onClick: function (e) {
                var _a;
                fireProperEventType(EventAction.TAP_DOCUMENT_UPLOAD_BUTTON, opts);
                onButtonClick === null || onButtonClick === void 0 ? void 0 : onButtonClick(e);
                (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
            } }, restButtonProps))));
};
export default DocumentUploadsFileUploadButton;
